export const updateAddToCartButtonText = (buttonIndex) => {
  $(`#addToCart_${buttonIndex}`)
    .addClass('added-to-cart')
    .find('.button__text')
    .text('Added to bag');
};
